import { useEffect } from 'react';
import { useCovidRegistration } from '../../../../hooks/covid-registration';
import moment from 'moment';
import { useMe } from '../../../../hooks/me';

export function AppSystemCovidRegistration() {
    const { user } = useMe();
    const { lastRegistration, resetLastRegistration, updateForm } = useCovidRegistration();
    const lastRegistrationDate = lastRegistration?.date;

    useEffect(() => {
        if (lastRegistrationDate) {
            const isPast = moment().subtract(10, 'days').isAfter(moment(lastRegistrationDate));

            if (isPast) {
                resetLastRegistration();
            }
        }
    }, [lastRegistrationDate]);

    useEffect(() => {
        if (user) {
            updateForm({
                name: `${user.firstName || ''} ${user.lastName || ''}`.trim(),
                areaCode: user.areaCode,
                phone: user.phone,
            });
        }
    }, [user]);

    return null;
}
